"use client";

import { useQuery } from "@tanstack/react-query";

export type BlogListParams = {
  page?: string;
  q?: string;
  tag?: string;
};

export type BlogPostListItem = {
  id: string;
  slug: string;
  title: string;
  content_markdown: string;
  content_html: string;
  meta_description: string | null;
  image_url: string | null;
  tags: string[];
  created_at: string;
  published_at: string;
  updated_at: string;
};

export type BlogPostsResponse = {
  q: string;
  tag: string;
  page: number;
  items: BlogPostListItem[];
  total: number;
  totalPages: number;
};

async function fetchBlogPosts(params: BlogListParams): Promise<BlogPostsResponse> {
  const search = new URLSearchParams();

  if (params.page) search.set("page", params.page);
  if (params.q) search.set("q", params.q);
  if (params.tag) search.set("tag", params.tag);

  const res = await fetch(`/api/blog?${search.toString()}`, {
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error("Failed to fetch blog posts");
  }

  return res.json();
}

export function useBlogPosts(params: BlogListParams) {
  return useQuery({
    queryKey: ["blog-posts", params.page ?? "1", params.q ?? "", params.tag ?? ""],
    queryFn: () => fetchBlogPosts(params),
    staleTime: 60_000,
  });
}
